var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16C17.8413 16 19.3674 15.3679 20.4926 14.2426C21.6179 13.1174 22.25 11.5913 22.25 10C22.25 8.4087 21.6179 6.88258 20.4926 5.75736C19.3674 4.63214 17.8413 4 16.25 4C14.6587 4 13.1326 4.63214 12.0074 5.75736C10.8821 6.88258 10.25 8.4087 10.25 10C10.25 11.5913 10.8821 13.1174 12.0074 14.2426C13.1326 15.3679 14.6587 16 16.25 16ZM20.25 10C20.25 11.0609 19.8286 12.0783 19.0784 12.8284C18.3283 13.5786 17.3109 14 16.25 14C15.1891 14 14.1717 13.5786 13.4216 12.8284C12.6714 12.0783 12.25 11.0609 12.25 10C12.25 8.93913 12.6714 7.92172 13.4216 7.17157C14.1717 6.42143 15.1891 6 16.25 6C17.3109 6 18.3283 6.42143 19.0784 7.17157C19.8286 7.92172 20.25 8.93913 20.25 10ZM28.25 26C28.25 28 26.25 28 26.25 28H6.25C6.25 28 4.25 28 4.25 26C4.25 24 6.25 18 16.25 18C26.25 18 28.25 24 28.25 26ZM26.25 25.992C26.248 25.5 25.942 24.02 24.586 22.664C23.282 21.36 20.828 20 16.25 20C11.67 20 9.218 21.36 7.914 22.664C6.558 24.02 6.254 25.5 6.25 25.992H26.25Z",
    fill: "#192F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson1);
export default __webpack_public_path__ + "static/media/person-1.555eccf51054448197676395c31439ad.svg";
export { ForwardRef as ReactComponent };